
import Hero from './hero.svg';
import ApiDevelopment from './app-development/api-development.svg';
import ECommerce from './app-development/e-commerce.svg';
import Enterprise from './app-development/enterprise.svg';
import Pwa from './app-development/pwa.svg';
import WebPlatform from './app-development/web-platform.svg';
import ApiDevelopmentMin from './app-development/api-development_480.svg';
import ECommerceMin from './app-development/e-commerce_480.svg';
import EnterpriseMin from './app-development/enterprise_480.svg';
import PwaMin from './app-development/pwa_480.svg';
import WebPlatformMin from './app-development/web-platform_480.svg';
import Healthcare from './solutions/healthcare.svg';
import Finance from './solutions/finance-banking.svg';
import Logistics from './solutions/logistics.svg';
import Retail from './solutions/retail.svg';
import Education from './solutions/education.svg';
import Optimized from './choose/optimized.svg';
import Adaptive from './choose/adaptive-architecture.svg';
import Proven from './choose/proven-expertise.svg';
import Regorous from './choose/rigorous.svg';
import Business from './choose/business-driven.svg';
import Discovery from './keys/discovery.png';
import Deployment from './keys/deployment.png';
import Development from './keys/development.png';
import Design from './keys/design.png';
import Ongoing from './keys/ongoing.png';
import Testing from './keys/testing.png';
import Android from './tech/android.svg';
import Angular from './tech/angular.svg';
import Aws from './tech/aws.svg';
import ChatGpt from './tech/chatGpt.svg';
import Docker from './tech/docker.svg';
import Flutter from './tech/flutter.svg';
import Git from './tech/git.svg';
import Google from './tech/google.svg';
import Ios from './tech/ios.svg';
import Java from './tech/java.svg';
import Jira from './tech/jira.svg';
import Nest from './tech/nest.svg';
import Next from './tech/next.svg';
import Nodejs from './tech/nodejs.svg';
import Php from './tech/php.svg';
import Python from './tech/python.svg';
import ReactNative from './tech/react-native.svg';
import React from './tech/react.svg';
import Vue from './tech/vue.svg';
import OgImage from './og_image.png';


export {
  Hero,
  ApiDevelopment,
  ECommerce,
  Enterprise,
  Pwa,
  WebPlatform,
  ApiDevelopmentMin,
  ECommerceMin,
  EnterpriseMin,
  PwaMin,
  WebPlatformMin,
  Healthcare,
  Finance,
  Logistics,
  Retail,
  Education,
  Optimized,
  Adaptive,
  Proven,
  Regorous,
  Business,
  Discovery,
  Deployment,
  Development,
  Design,
  Ongoing,
  Testing,
  Android,
  Angular,
  Aws,
  ChatGpt,
  Docker,
  Flutter,
  Git,
  Google,
  Ios,
  Java,
  Jira,
  Nest,
  Next,
  Nodejs,
  Php,
  Python,
  ReactNative,
  React,
  Vue,
  OgImage,
}
